import React, { useCallback, useState, useRef, useMemo, useEffect } from "react";
import { Button, message, Modal, Checkbox, Spin } from 'antd';
import Viewer from 'viewer';
import 'viewer/dist/viewer.css'
import { recoverPics, getRecycleBinList, updateRotate } from '../../../service/report';
import './style.scss';

export default function RecycleList(props) {
  const [recycleBinList, setRecycleBinList] = useState([]);
  const [recycleBinRefresh, setRecycleBinRefresh] = useState(true);
  const [isSelectedAll, setIsSelectedAll] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);

  const previewList = useRef();
  const gallery = useRef();
  const imgIndex = useRef(0);
  const imgRef = useRef();

  const handleRotate = useCallback((curPic) => {
    if (curPic.rotate !== curPic.originalRotate) {
      let curRotate = curPic.rotate % 360;
      updateRotate({
        flowId: props.flowId,
        rotate: isNaN(curRotate) ? 0 : parseInt(curRotate),
        imgId: curPic._id,
        imgUrl: curPic.sourceUrl
      }).then(() => {
        setRecycleBinList(pics => pics.map((item) => item._id === curPic._id ? { ...curPic, originalRotate: curPic.rotate } : item));
        previewList.current = previewList.current.map(item => item._id === curPic._id ? { ...curPic, originalRotate: curPic.rotate } : item);
      });
    }
  }, [props]);

  // 回收站预览
  const previewByRecycle = useCallback((event) => {
    const { id } = event.target.dataset;
    previewList.current = recycleBinList;
    const index = previewList.current.findIndex((item) => item._id === id);
    imgIndex.current = index;
    if (gallery.current) {
      gallery.current.destroy();
    }

    const viewer = new Viewer(imgRef.current, {
      show: function () {
        if (previewList.current[index].rotate) {
          viewer.imageData.rotate = previewList.current[index].rotate;
        }
      },
      hidden: async () => {
        const curIndex = imgIndex.current, curPic = previewList.current[curIndex];
        handleRotate(curPic);
      },
      initialViewIndex: index,
      url(image) {
        return image.dataset.src;
      },
      transition: false,
      toolbar: {
        zoomIn: 4,
        zoomOut: 4,
        prev: async () => {
          const imgList = previewList.current;
          const curIndex = imgIndex.current, curPic = imgList[curIndex];
          const prevIndex = imgIndex.current <= 0 ? imgList.length - 1 : curIndex - 1, prevPic = imgList[prevIndex];
          imgIndex.current = prevIndex;
          viewer.imageData.rotate = prevPic.rotate;
          viewer.view(imgIndex.current)
          handleRotate(curPic);
        },
        next: async () => {
          const imgList = previewList.current;
          const curIndex = imgIndex.current, curPic = imgList[curIndex];
          const nextIndex = (curIndex + 1) % imgList.length, nextPic = imgList[nextIndex];
          imgIndex.current = nextIndex;
          viewer.imageData.rotate = nextPic.rotate;
          viewer.view(imgIndex.current);
          handleRotate(curPic);
        },
        rotateLeft: false,
        rotateRight: () => {
          const curIndex = imgIndex.current;
          const imgList = previewList.current;
          const curPic = imgList[curIndex], rotate = (curPic.rotate || 0) + 90;
          viewer.rotateTo(rotate);
          previewList.current = imgList.map((item, index) => String(index) === String(curIndex) ? { ...item, rotate } : item);
        }
      }
    });
    gallery.current = viewer;
    gallery.current.show();
    // handlePreview({
    //   ...args,
    //   onSuccess: (curPic) => {
    //     setRecycleBinList(pics => pics.map((item) => item._id === curPic._id ? { ...curPic, originalRotate: curPic.rotate } : item))
    //   }
    // });
  }, [recycleBinList, handleRotate]);


  // 全选/取消全选
  const onChange = useCallback((e) => {
    const { checked } = e.target;
    setIsSelectedAll(e.target.checked)
    if (checked) {
      setSelectedIds(recycleBinList.map(item => item._id));
    } else {
      setSelectedIds([]);
    }
  }, [recycleBinList]);

  // 恢复
  const handleRecover = useCallback(() => {
    if (!selectedIds.length) {
      message.error('请至少选择一张图片');
      return;
    }
    recoverPics({
      picIds: selectedIds,
      flowId: props.flowId
    }).then(() => {
      message.success('已恢复');
      setSelectedIds([]);
      setIsSelectedAll(false);
      setRecycleBinRefresh(true);
      props.onSuccess && props.onSuccess();
    })
  }, [props, selectedIds]);

  const onCancel = useCallback(() => {
    props.onCancel && props.onCancel();
  }, []);

  // 单选图片
  const selectPic = useCallback((e, picId) => {
    const { checked } = e.target;
    if (checked) {
      setSelectedIds([...selectedIds, picId])
    } else {
      setSelectedIds(selectedIds.filter(id => id !== picId));
    }
  }, [selectedIds]);

  const renderList = useMemo(() => {
    return recycleBinList && recycleBinList.length ? <ul className="list">{
      recycleBinList.map(item => <li key={item._id} data-id={item._id} >
        <div className="img">
          {/* 回收站接口已返回完整 OSS URL，不能再次拼接 staticUrl/bucket。 */}
          <img src={item.thumbnail_url} data-src={item.sourceUrl} data-id={item._id} alt="" style={{ transform: `rotate(${item.originalRotate || 0}deg)` }} onClick={previewByRecycle} />
          <p className="img-mark">
              {
                  item.referer === 'agent' ? <i className="iconfont icon-local" /> : null
              }
          </p>
        </div>
        <p>
          <span className="name">{item.subLabelName}</span>
        </p>
        {
          !props.disabled ? <span className="check-btn"><Checkbox checked={selectedIds.includes(item._id)} onChange={(event) => selectPic(event, item._id)} /></span> : null
        }
      </li>)
    }</ul> : <p style={{ textAlign: 'center', padding: 20 }}>暂无数据</p>
  }, [props, selectedIds, recycleBinList, selectPic, previewByRecycle]);

  useEffect(() => {
    if (!recycleBinRefresh) {
      return;
    }
    getRecycleBinList({ flowId: props.flowId }).then(({ result }) => {
      setRecycleBinList(result.pics.map(item => ({ ...item, originalRotate: item.rotate })));
      setRecycleBinRefresh(false);
    });
  }, [props, recycleBinRefresh]);

  return <React.Fragment>
    <Modal title={<div className="recycle-modal-header">
      <h2 className="recycle-modal-header-title">回收站</h2>
      {
        !props.disabled && recycleBinList.length ? <div className="recycle-wrap-btns"><Checkbox checked={isSelectedAll} onChange={onChange}>全选</Checkbox> <Button type="primary" onClick={handleRecover} disabled={!selectedIds.length}>恢复</Button></div> : null
      }
    </div>} visible={props.visible} onCancel={onCancel} width={780} footer={null} bodyStyle={{ padding: 10, maxHeight: 500, overflowY: 'auto', overflowX: 'hidden' }} destroyOnClose className="recycle-modal" closable={false}>
      <div className="recycle-wrap" ref={imgRef}>
        <Spin spinning={recycleBinRefresh}>
          {renderList}
        </Spin>
      </div>
    </Modal>
  </React.Fragment>
}
